import type { Vector3 } from "@mind-sands/shared";

/** Subset of the meshRegistry bounding box needed for display. */
interface Bounds {
  size: [number, number, number];
  center: [number, number, number];
}

/**
 * Read-only pivot point and world-space bounding box of the selected object.
 */
export function ObjectBoundsPanel({
  position,
  boundingBox,
}: {
  position: Vector3;
  boundingBox: Bounds | null;
}) {
  return (
    <>
      {/* Pivot point (read-only) */}
      <div className="mb-3">
        <p className="text-[10px] font-medium text-sands-500 uppercase tracking-wider mb-1.5">
          Pivot
        </p>
        <div className="grid grid-cols-3 gap-1.5 text-xs text-sands-600">
          <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
            <span className="text-sands-400">X</span> {position[0].toFixed(2)}
          </div>
          <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
            <span className="text-sands-400">Y</span> {position[1].toFixed(2)}
          </div>
          <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
            <span className="text-sands-400">Z</span> {position[2].toFixed(2)}
          </div>
        </div>
      </div>

      {/* Bounding box (read-only) */}
      {boundingBox && (
        <div className="mb-3">
          <p className="text-[10px] font-medium text-sands-500 uppercase tracking-wider mb-1.5">
            Bounds
          </p>
          <div className="grid grid-cols-3 gap-1.5 text-xs text-sands-600">
            <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
              <span className="text-sands-400">W</span>{" "}
              {boundingBox.size[0].toFixed(2)}
            </div>
            <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
              <span className="text-sands-400">H</span>{" "}
              {boundingBox.size[1].toFixed(2)}
            </div>
            <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
              <span className="text-sands-400">D</span>{" "}
              {boundingBox.size[2].toFixed(2)}
            </div>
          </div>
          <div className="grid grid-cols-3 gap-1.5 text-xs text-sands-600 mt-1">
            <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
              <span className="text-sands-400">CX</span>{" "}
              {boundingBox.center[0].toFixed(2)}
            </div>
            <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
              <span className="text-sands-400">CY</span>{" "}
              {boundingBox.center[1].toFixed(2)}
            </div>
            <div className="px-2 py-1 bg-sands-50 border border-sands-200 rounded-lg text-center">
              <span className="text-sands-400">CZ</span>{" "}
              {boundingBox.center[2].toFixed(2)}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
